import React, { useRef, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import getChartColorsArray from "./ChartsDynamicColor";

const Pie = ({dataColors, examDetails, onSliceClick}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const instance = chartRef.current?.getEchartsInstance?.();
    if (!instance) return;
    const handleClick = (params) => {
      if (onSliceClick) {
        onSliceClick(params.name);
      }
    };
    instance.on('click', handleClick);
    return () => {
      instance.off('click', handleClick);
    };
  }, [onSliceClick]);

const piecolors = ["#34c38f", "#f1b44c", "#f04343", "#50a5f1"]
  const PieEChartColors = getChartColorsArray(dataColors);
  const options = {
    toolbox: {
      show: false,
    },
    tooltip: {
      show: false,
    },
    legend: {
      orient: "vertical",
      left: "left",
      // data: ["Total Questions", "Wrong Answer", "Unanswered Questions", "Correct Answers"],
      data: [ "Correct Answers", "Wrong Answer", "Not Answered Questions"],
      textStyle: {
        color: ["#8791af"],
      },
    },
    color: piecolors,
    series: [
      {
        name: "Total Answered",
        type: "pie",
        radius: "45%",
        center: ["40%", "55%"],
        data: [
          { value: examDetails[0]?.correctanswered, name: "Correct Answers" },
          { value: examDetails[0]?.unanswered, name: "Not Answered Questions" },
          { value: examDetails[0]?.wronganswer, name: "Wrong Answer" },
          // { value: 1548, name: "Total Questions" },
          // Number(examDetails[0]?.correctanswered !=0) &&  { value: examDetails[0]?.correctanswered, name: "Correct Answers" },
          // Number(examDetails[0]?.unanswered !=0) && { value: examDetails[0]?.unanswered, name: "Unanswered Questions" },
          // Number(examDetails[0]?.wronganswer !=0) &&  { value: examDetails[0]?.wronganswer, name: "Wrong Answer" },
        ],
        label: {
          show: true,
          formatter: "{b} : {c} ({d}%)",
          fontSize: 12,
        },
        labelLine: {
          show: true,
          length: 8,
          length2: 8,
        },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };
  return (
    <React.Fragment>
      <ReactEcharts ref={chartRef} style={{ height: "350px" }} option={options} />
    </React.Fragment>
  );
};
export default Pie;